import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import PasswordView from '../../components/Customer/Profile/PasswordView';
import ProfileWrapper from '../../components/Customer/ProfileWrapperView';
import {bindActionCreators} from "redux";
import * as userActions from "../../actions/userActions";
import {actionWrapper} from '../../helpers/index';
import ConfirmView from "../../components/Helpers/ConfirmView";
import * as _ from 'lodash';


class ResetLayout extends Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.clearError = this.clearError.bind(this);
    this.state = {
      inProgress: false,
      showConfirm: false,
      confirm: {},
      errors: {}
    }
  }

  close() {
    let url = '/';
    if (!_.isUndefined(this.props.restaurant) && Object.keys(this.props.restaurant)) {
      url = `/${this.props.restaurant.name_for_url}/products/pizza`;
    }
    this.props.history.push(url);
  }

  resetPassword(data) {
    const {password, confirmPassword} = data;
    let error = [];
    if (password === '') {
      error.push('password_empty');
    }
    if (confirmPassword === '') {
      error.push('confirm_password_empty');
    }
    if (!error.length) {
      if (password.length < 6) {
        error.push('password_length');
      }
      if (confirmPassword.length < 6) {
        error.push('confirm_password_length');
      }
    }
    if (!error.length) {
      if (password !== confirmPassword) {
        error.push('wrong_confirm_password');
      }
    }
    if (!error.length) {
      const resetData = {
        ...data,
        ...this.props.match.params
      };
      actionWrapper(this, resetData, this.props.resetPassword).then(() => {
        this.showConfirm('reset', true)
      });
    } else {
      this.setState({
        errors: {
          error: error
        }
      })
    }
  }

  showConfirm(action, success = false) {
    this.setState({
      showConfirm: true,
      confirm: {
        success: success,
        action: action,
        onConfirm: this.close
      }
    })
  }

  clearError() {
    this.setState({
      errors: {}
    })
  }

  render() {
    const {inProgress, confirm, showConfirm, errors} = this.state;
    return (
      <ProfileWrapper onClose={this.close}>
        {!showConfirm ?
          <div className='profile__reset-password'>
            <PasswordView
              inProgress={inProgress}
              action={this.resetPassword}
              errors={errors}
              profile={{}}
              current={false}
              clearError={this.clearError}
            />
          </div>:
          <ConfirmView config={confirm}/>
        }
      </ProfileWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    restaurant: state.restaurants.item
  };
}


function mapDispatchToProps(dispatch) {
  return {
    resetPassword: bindActionCreators(userActions.resetPassword, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetLayout));


// WEBPACK FOOTER //
// ./src/containers/Customer/Reset.js